var _defs, _g, _g2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDocumentRetrieval(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;}.cls-2{fill:#1f1f1f;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "abb_search_32") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Box"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    width: 32,
    height: 32
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Final_icons_-_Common",
    "data-name": "Final icons - Common"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M29,26l-8.48-8.48a9.52,9.52,0,0,0,1.48-5A9.42,9.42,0,0,0,12.57,3h0A9.59,9.59,0,0,0,3,12.53,9.42,9.42,0,0,0,12.43,22h0a9.52,9.52,0,0,0,5-1.48L26,29ZM12.46,20a7.25,7.25,0,0,1-5.29-2.17A7.38,7.38,0,0,1,5,12.54,7.58,7.58,0,0,1,12.54,5h0A7.41,7.41,0,0,1,20,12.46,7.58,7.58,0,0,1,12.46,20Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocumentRetrieval);
export default __webpack_public_path__ + "static/media/DocumentRetrieval.0737a4bb374e41a35fea27d066902582.svg";
export { ForwardRef as ReactComponent };